import React from 'react'

export const Procedure = props => (
  <svg
    width={48}
    height={48}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path 
        d="M36 4C38.2092 4 40 5.79086 40 8V40C40 42.2092 38.2092 44 36 44H12C9.79086 44 8 42.2092 8 40V8C8 5.79086 9.79086 4 12 4H36ZM24 26H18C16.8954 26 16 26.8954 16 28C16 29.1046 16.8954 30 18 30H24C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26ZM30 16H18C16.8954 16 16 16.8954 16 18C16 19.0257 16.7721 19.871 17.7668 19.9865L18 20H30C31.1046 20 32 19.1046 32 18C32 16.9743 31.2279 16.129 30.2332 16.0135L30 16Z" 
    />
  </svg>
)